import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { getSelectedStore } from 'x/redux/selectors'

import { TouchableOpacity, View } from 'react-native'

import p from 'x/config/platform-specific'
import CONS from 'x/config/constants'
import * as util from 'x/utils/util'
import * as api from 'x/utils/api'
import { COLORS, S } from 'x/config/styles'
import { ICrmChannelCreateViewProps, ICrmChannelCreateViewState, IXSegmentOption, ICrmChannel } from 'x/types'

// import BackIcon from 'xui/components/BackIcon'
import VStack from 'xui/components/VStack'
import XText from 'xui/components/XText'
import XContent from 'xui/components/XContent'
import XContainer from 'xui/components/XContainer'
import XCustomHeader from 'xui/components/XCustomHeader'
import * as NavActions from 'x/utils/navigation'
import HStack from 'xui/components/HStack'
import XImage from 'xui/components/XImage'
import XIconButton from 'xui/components/XIconButton'
import XIcon from 'xui/components/XIcon'
import CrmLogo from 'xui/components/CrmLogo'
import XCard from 'xui/components/XCard'
import XSpinner from 'xui/components/XSpinner'
import XInput from 'xui/components/XInput'
import XRadio from 'xui/components/XRadio'
import XButton from 'xui/components/XButton'

class CrmChannelCreateView extends React.Component<ICrmChannelCreateViewProps, ICrmChannelCreateViewState> {
  static displayName = 'CrmChannelCreateView'

  _inProcess?: boolean

  constructor(props: ICrmChannelCreateViewProps) {
    super(props)
    this.state = {
      isInitialized: false,
      crm_system_id: -1,
    }
  }

  async componentDidMount() {
    await this._initializeView()
  }

  _initializeView = async () => {
    await util.setStatePromise(this, { isInitialized: false, products: [], selectedReason: null })
    // Init activeStatesMap
    const newState: Partial<ICrmChannelCreateViewState> = {}
    // get ready to render
    newState.isInitialized = true

    await util.setStatePromise(this, newState)
  }

  _goBack = () => {
    util.navGoBack(this.props)
  }

  _navToCrmCreateViewByCrmSystemId = () => {
    const { crm_system_id } = this.state

    if (crm_system_id === 1) {
      // Deepblok
      this._navToCrmCreateDeepBlokView()
    }
  }

  _onCreatedSuccess = (newCrmChannel: ICrmChannel) => {
    const onCreatedSuccess = util.getNavParam(this.props, 'onCreatedSuccess')
    if (onCreatedSuccess) {
      onCreatedSuccess(newCrmChannel)
    }
    this._goBack()
  }

  _navToCrmCreateDeepBlokView = () => {
    const { navigation } = this.props
    const store_id = util.getNavParam(this.props, 'store_id')

    navigation.dispatch(
      NavActions.navToCrmChannelCreateDeepBlokView({
        store_id,
        crm_system_id: 1,

        onCreatedSuccess: this._onCreatedSuccess,
      })
    )
  }

  _renderCustomHeader = () => {
    return <XCustomHeader title={p.op.t('crm.channelCreateView.title')} headerLeftProps={{ backIcon: true, onPressItem: this._goBack }} />
  }

  _onSelectCrmSystem = (crm_system_id: number) => {
    this.setState({ crm_system_id })
  }

  _renderPickChannelDeepblok = () => {
    const { crm_system_id } = this.state
    const isSelected = crm_system_id === 1

    return (
      <XCard w='full' p='2'>
        <TouchableOpacity onPress={() => this._onSelectCrmSystem(1)} style={{ flex: 1, width: '100%' }}>
          <HStack
            borderRadius='md'
            w='full'
            alignItems='center'
            py='2'
            borderWidth='1'
            borderColor={isSelected ? COLORS.APP_MAIN : COLORS.TEXT_INACTIVE}
          >
            {isSelected ? (
              <HStack w='34px' alignItems='center'>
                <XIcon name='caret-right' family='AntDesign' />
              </HStack>
            ) : (
              <HStack w='34px' />
            )}

            <CrmLogo crmSystemId={1} width={48} height={48} />

            <HStack w='2' />
            <HStack style={{ flex: 1 }}>
              <XText bold fontSize='md' variant='active' t={'crm.crm_system_name_by_id.1'} />
            </HStack>
          </HStack>
        </TouchableOpacity>
      </XCard>
    )
  }

  _isFormValid = () => {
    const { crm_system_id } = this.state

    if (!crm_system_id || crm_system_id < 1) {
      return false
    }

    return true
  }

  _renderFooter = () => {
    const isFormValid = this._isFormValid()
    const isDisabled = !isFormValid

    return (
      <HStack w='full' p='2' bg='white' alignItems='center' justifyContent='center'>
        <XButton disabled={isDisabled} isDisabled={isDisabled} w='full' h='34px' onPress={this._navToCrmCreateViewByCrmSystemId}>
          ดำเนินการต่อ
        </XButton>
      </HStack>
    )
  }

  _renderContent = () => {
    const { isInitialized, isRefreshing } = this.state
    if (!isInitialized) {
      return null
    }

    if (isRefreshing) {
      return (
        <VStack w='full' p='2'>
          <XSpinner />
        </VStack>
      )
    }

    return (
      <VStack w='full' px='4' py='2' bg='white' space='1'>
        <HStack w='full' alignItems='center'>
          <XText variant='inactive' fontSize='md' t={'crm.channelCreateView.selectCrmSystem'} />
        </HStack>

        {this._renderPickChannelDeepblok()}
      </VStack>
    )
  }

  render() {
    return (
      <XContainer>
        {this._renderCustomHeader()}
        <XContent>{this._renderContent()}</XContent>
        {this._renderFooter()}
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(CrmChannelCreateView)
